import XLSX from "xlsx"

const getNamedRanges = ({ wb, prefix }) => {
	/**
	 * @param ref - coming from xlsx, e.g. Sheet1!$C$1, or Sheet1!$C$1:$E$2
	 */
	const parseNamedRangeReference = (ref = "") => {
		if (!ref) return ""

		const splitReference = ref.split("!") || []
		const sheet = splitReference?.[0]
		const cell = splitReference?.[1]

		// Construct output
		const output = {
			sheet,
			cell: null,
			range: null
		}

		// Check if it is a range or a cell
		if (cell.includes(":"))
			output.range = {
				startCell: cell.split(":")?.[0]?.replace(/\$/gi, ""),
				endCell: cell.split(":")?.[1]?.replace(/\$/gi, "")
			}
		else output.cell = cell.replace(/\$/gi, "")

		return output || {}
	}

	const namedRanges = wb?.Workbook?.Names || []
	const parsedNamedRanges = namedRanges.map(namedRange => ({
		name: namedRange?.Name,
		ref: namedRange?.Ref,
		...parseNamedRangeReference(namedRange?.Ref)
	}))

	return parsedNamedRanges?.filter(item => item?.name?.includes(prefix)) || []
}

const determineDataTypeFromXlsx = xlsxDataType => {
	// Follows docs of xlsx
	// https://github.com/SheetJS/sheetjs#cell-object
	const dictionary = {
		s: "string",
		b: "boolean",
		n: "number",
		e: "error",
		d: "date",
		z: "stub"
	}

	return dictionary?.[xlsxDataType] || null
}

const getDataSchemaFromXlsx = ({ wb = {}, prefix = "" }) => {
	if (!wb) throw new Error("No `wb` from xlsx library passed")
	if (!prefix) throw new Error("No `prefix` passed")

	const namedRanges = getNamedRanges({ wb, prefix })

	const dataSchema = namedRanges.map(namedRange => {
		const sheet = namedRange?.sheet
		const cell = namedRange?.cell
		const range = namedRange?.range
		// Remove `input_` or `output_` from name based on prefix
		const label = namedRange?.name

		if (cell) {
			return {
				label,
				dataType: determineDataTypeFromXlsx(wb.Sheets?.[sheet]?.[cell]?.t),
				children: []
			}
		}

		if (range) {
			const output = {
				label,
				dataType: "array",
				children: [{ label, dataType: "object", children: [] }]
			}

			// Get coordinates of header
			const startCellCoo = XLSX.utils.decode_cell(range.startCell)
			const endCellCoo = XLSX.utils.decode_cell(range.endCell)
			let headerStartCol = startCellCoo.c
			let headerEndCol = endCellCoo.c
			let headerStartRow = startCellCoo.r

			// Get values of header cells and use it as labels of the object
			// Get also dataTypes from firstRowCells
			for (let i = headerStartCol; i <= headerEndCol; i++) {
				const headerCell = XLSX.utils.encode_cell({ c: i, r: headerStartRow })
				const firstRowCell = XLSX.utils.encode_cell({
					c: i,
					r: headerStartRow + 1
				})

				output.children[0].children.push({
					label: wb.Sheets?.[sheet]?.[headerCell]?.v,
					dataType: determineDataTypeFromXlsx(
						wb.Sheets?.[sheet]?.[firstRowCell]?.t
					)
				})
			}
			return output
		}
	})

	return dataSchema
}

export { getDataSchemaFromXlsx }
